module.exports = __webpack_public_path__ + "static/media/Lato-Black.827d7278.eot";